import { css } from "@emotion/react";

import { DesignToken, RadiusToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const videoControlsStyles = css({
  position: "absolute",
  width: "100%",
  height: "100%",
  display: "flex",
  border: "none",
  background: "transparent",
  cursor: "pointer",
  inset: "0",
  zIndex: 1,
  justifyContent: "center",
  alignItems: "center",
});

export const playButtonStyles = css({
  background: withVar(DesignToken.SurfaceInvertPrimary),
  borderRadius: "50%",
  padding: "1rem",
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const maxWidthStyles = (maxWidth: string) =>
  css({
    maxWidth: `min(100%, ${maxWidth})`,
  });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const wrapperStyles = (maxWidth: string) =>
  css(maxWidthStyles(maxWidth), {
    maxWidth: "min(100%, 800px)",
    position: "relative",
  });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const videoStyles = (maxWidth: string) =>
  css(maxWidthStyles(maxWidth), {
    borderRadius: withVar(RadiusToken.Radius2),
  });
